import React from 'react';

const sizeMap = {
  sm: { main: 'text-[20px] sm:text-[24px]', sub: 'text-[9px] sm:text-[10px]' },
  md: { main: 'text-[26px] sm:text-[32px]', sub: 'text-[10px] sm:text-[12px]' },
  lg: { main: 'text-[36px] sm:text-[46px] md:text-[54px]', sub: 'text-[12px] sm:text-[15px] md:text-[17px]' },
  xl: { main: 'text-[44px] sm:text-[60px] md:text-[74px]', sub: 'text-[14px] sm:text-[18px] md:text-[22px]' },
};

const goldText = {
  background: 'linear-gradient(180deg, #F6E3A1 0%, #D4AF37 50%, #A8832E 100%)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
};

const Logo = ({ size = 'md' }) => {
  const s = sizeMap[size];
  return (
    <div data-testid="brand-logo" className="inline-flex flex-col items-center leading-none select-none" style={{ direction: 'ltr' }}>
      <span
        className={`${s.main} whitespace-nowrap`}
        style={{ ...goldText, fontFamily: "'Cormorant Garamond', 'Italiana', Georgia, serif", fontWeight: 600, letterSpacing: '0.08em' }}
      >
        GOLD CARE
      </span>
      <span
        className={`${s.sub} mt-1`}
        style={{ ...goldText, fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, letterSpacing: '0.55em', paddingLeft: '0.55em' }}
      >
        ESTHETIC
      </span>
    </div>
  );
};

export default Logo;
